import { render } from "./inventorysubcategory.vue?vue&type=template&id=0f25d0e8&scoped=true"
import script from "./inventorysubcategory.vue?vue&type=script&lang=js"
export * from "./inventorysubcategory.vue?vue&type=script&lang=js"

import "./inventorysubcategory.vue?vue&type=style&index=0&id=0f25d0e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f25d0e8"]])

export default __exports__